import { BP42InitialState } from '@r1-frontend/bp42/reducer/initialState';

const isNeedToShowResult = (state: BP42InitialState): boolean => state.needToShowResponseResult;

export default isNeedToShowResult;
